export interface ICurrentUser {
  DatosResult: IDatosResultCurrentUser;
  Mensajes:    any[];
  LoginDatos:  null;
}

export interface IDatosResultCurrentUser {
  ListaCentros?:      any[];
  NombreUsuario:     string;
  TipoUsuarioId:     string | number;
  DeBaja:            string;
  Conectado:         string;
  CodEmpleado:       string;
  Id:                string | number;
  Nombre:            string;
  Descripcion:       string;
  Privilegios:       string;
  Token:             string;
  CentrosNombres:    string;
  UltimaFechaAcceso: string;
  Permisos:          Permiso[];
}

export interface Permiso {
  AccionId:           string;
  NombreAccion:       string;
  CodigoAccion:       string;
  ModuloId:           string;
  CodigoModulo:       string;
  NombreModulo:       string;
  Ventana:            string;
  ModuloIdPadre:      string;
  NombreApp:          NombreApp;
  NombreIdioma:       string;
  NombreModuloIdioma: string;
}

export enum NombreApp {
  Customan = "CUSTOMAN",
}
